import { render, staticRenderFns } from "./appointment_academic_show.vue?vue&type=template&id=d8b55c4c"
import script from "./appointment_academic_show.vue?vue&type=script&lang=js"
export * from "./appointment_academic_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports